import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取提单预报列表
export const getPlatReturnService = (params) => {
  return axios.request({
    url: "/warehouse/platformReturn",
    method: "get",
    params,
  });
};

// 获取备注列表
export const getRemarkList = (params) => {
  return axios.request({
    url: "/warehouse/platformReturn/getRemarks",
    method: "get",
    params,
  });
};

// 新增备注
export const addRemark = (data) => {
  return axios.request({
    url: "/warehouse/platformReturn/addRemarks",
    method: "post",
    data,
  });
};

// 获取货物详情
export const getPlatReturnDetail = (params) => {
  return axios.request({
    url: "/warehouse/platformReturn/details/" + params.id,
    method: "get",
  });
};
// // 删除备注
// export const delRemark = (id) => {
//   return axios.request({
//     url: "/warehouse/prediction/remarks/" + id,
//     method: "delete",
//   });
// };

// // 导出
// export const exportExcel = (params) => {
//   return axios.request({
//     url: "/warehouse/prediction/export",
//     method: "get",
//     params,
//   });
// };


export const batchAddRemarks = (data) => {
  return axios.request({
    url: "/warehouse/platformReturn/batchAddRemarks",
    method: "post",
    data,
  });
};
